import { DestinationAdapter } from './base-adapter.js';

class MetaPixelAdapter extends DestinationAdapter {
  get name() {
    return 'META_PIXEL';
  }

  isInitialized() {
    return typeof window.fbq === 'function';
  }

  async initialize(credentials) {
    const { pixelId } = credentials;

    if (!pixelId) {
      console.error('EventFoundry: Meta Pixel adapter missing pixelId');
      return false;
    }

    // Validate pixel ID format (numeric string)
    if (!pixelId.match(/^\d+$/)) {
      console.error(`EventFoundry: Invalid Meta Pixel ID format: ${pixelId}`);
      return false;
    }

    // Check if fbq already exists
    if (this.isInitialized()) {
      console.log('EventFoundry: Using existing Meta Pixel installation');
      return true;
    }

    // Inject Meta Pixel base code
    !function(f,b,e,v,n,t,s) {
      if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)
    }(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');

    // Wait for fbq to be available
    await new Promise((resolve) => {
      if (typeof window.fbq === 'function') {
        resolve();
      } else {
        setTimeout(resolve, 1000); // Give it 1 second
      }
    });

    // Verify fbq exists
    if (!this.isInitialized()) {
      console.error('EventFoundry: fbq not available after load');
      return false;
    }

    // Initialize pixel
    window.fbq('init', pixelId);

    // Track automatic PageView
    window.fbq('track', 'PageView');

    console.log('EventFoundry: Meta Pixel initialized successfully');
    return true;
  }

  fireEvent(eventKey, params) {
    if (!this.isInitialized()) {
      console.error('EventFoundry: fbq not available - cannot fire event');
      return;
    }

    // BETA: All events fire as Custom Events
    window.fbq('trackCustom', eventKey, params);
  }
}

export const metaPixelAdapter = new MetaPixelAdapter();
